const $de6ddf51c250e19d$export$6b5c1ceb16d01dc3 = Math.PI;
const $de6ddf51c250e19d$export$ad5b0b9ab7d48f58 = $de6ddf51c250e19d$export$6b5c1ceb16d01dc3 * 2;
const $de6ddf51c250e19d$export$f504979d7e0a75c7 = $de6ddf51c250e19d$export$6b5c1ceb16d01dc3 / 2;
const $de6ddf51c250e19d$export$b1eb83e43ef0f9f8 = $de6ddf51c250e19d$export$6b5c1ceb16d01dc3 / 3;
const $de6ddf51c250e19d$export$cfa25d10e00ab635 = $de6ddf51c250e19d$export$6b5c1ceb16d01dc3 / 4;
const $de6ddf51c250e19d$export$4b53cc5148232136 = $de6ddf51c250e19d$export$6b5c1ceb16d01dc3 / 6;
const $de6ddf51c250e19d$export$588dca789ffa0fd0 = 1 / $de6ddf51c250e19d$export$6b5c1ceb16d01dc3;
const $de6ddf51c250e19d$export$3a7bf289cac70393 = 1 / $de6ddf51c250e19d$export$ad5b0b9ab7d48f58;
const $de6ddf51c250e19d$export$24b096bfbaf849b7 = 1 / $de6ddf51c250e19d$export$f504979d7e0a75c7;
const $de6ddf51c250e19d$export$460c4029b1a54a2e = $de6ddf51c250e19d$export$6b5c1ceb16d01dc3 / 180;
const $de6ddf51c250e19d$export$914076c8150813e5 = 180 / $de6ddf51c250e19d$export$6b5c1ceb16d01dc3;
const $de6ddf51c250e19d$export$ed904dc4011d96f7 = (1 + Math.sqrt(5)) / 2;
const $de6ddf51c250e19d$export$3681641e15b6e2c3 = Math.SQRT2;
const $de6ddf51c250e19d$export$1b2407b91ae96221 = Math.sqrt(3);
const $de6ddf51c250e19d$export$2bfcf97b5c0e010 = $de6ddf51c250e19d$export$3681641e15b6e2c3 / 2;
const $de6ddf51c250e19d$export$d98365b4d5f896cf = $de6ddf51c250e19d$export$1b2407b91ae96221 / 2;
const $de6ddf51c250e19d$export$f76cf7896cad0d31 = 1 / 3;
const $de6ddf51c250e19d$export$2ff8b3422c5a9edf = 2 / 3;
const $de6ddf51c250e19d$export$d7977f56a0faa834 = 1 / 6;
let $de6ddf51c250e19d$export$56469a43a57ad8b6 = 1e-6;


const $52309310b7ef39b9$var$mi = -Infinity;
const $52309310b7ef39b9$var$mx = Infinity;
const $52309310b7ef39b9$export$df24318f7b7a47df = Object.freeze([
    $52309310b7ef39b9$var$mi,
    $52309310b7ef39b9$var$mi
]);
const $52309310b7ef39b9$export$d0ebc6d8df6f38f1 = Object.freeze([
    $52309310b7ef39b9$var$mx,
    $52309310b7ef39b9$var$mx
]);
const $52309310b7ef39b9$export$b07c55cad352613c = Object.freeze([
    1,
    1
]);
const $52309310b7ef39b9$export$c2fad5ac839d6a20 = Object.freeze([
    0,
    0
]);
const $52309310b7ef39b9$export$3d76695dcdb4727a = Object.freeze([
    1,
    0
]);
const $52309310b7ef39b9$export$2f0e6bc49da0388c = Object.freeze([
    0,
    1
]);
const $52309310b7ef39b9$export$bd79be661f4ebe1f = Object.freeze([
    $52309310b7ef39b9$var$mi,
    $52309310b7ef39b9$var$mi,
    $52309310b7ef39b9$var$mi
]);
const $52309310b7ef39b9$export$9c6031f1a17fe1c1 = Object.freeze([
    $52309310b7ef39b9$var$mx,
    $52309310b7ef39b9$var$mx,
    $52309310b7ef39b9$var$mx
]);
const $52309310b7ef39b9$export$c41c0154fcf1768c = Object.freeze([
    1,
    1,
    1
]);
const $52309310b7ef39b9$export$8b0b3f9a2d1cfdb4 = Object.freeze([
    0,
    0,
    0
]);
const $52309310b7ef39b9$export$6206fb01145c2fc7 = Object.freeze([
    1,
    0,
    0
]);
const $52309310b7ef39b9$export$cdf9cc3fd2d632ca = Object.freeze([
    0,
    1,
    0
]);
const $52309310b7ef39b9$export$daec30a5ef5beb6b = Object.freeze([
    0,
    0,
    1
]);
const $52309310b7ef39b9$export$cd773ae416c5c457 = Object.freeze([
    $52309310b7ef39b9$var$mi,
    $52309310b7ef39b9$var$mi,
    $52309310b7ef39b9$var$mi,
    $52309310b7ef39b9$var$mi
]);
const $52309310b7ef39b9$export$4a1470f29ced2012 = Object.freeze([
    $52309310b7ef39b9$var$mx,
    $52309310b7ef39b9$var$mx,
    $52309310b7ef39b9$var$mx,
    $52309310b7ef39b9$var$mx
]);
const $52309310b7ef39b9$export$d910f96f79280336 = Object.freeze([
    1,
    1,
    1,
    1
]);
const $52309310b7ef39b9$export$75d254fcf3149d8c = Object.freeze([
    0,
    0,
    0,
    0
]);
const $52309310b7ef39b9$export$a0836bef9f1ade50 = Object.freeze([
    1,
    0,
    0,
    0
]);
const $52309310b7ef39b9$export$79268303819edbbe = Object.freeze([
    0,
    1,
    0,
    0
]);
const $52309310b7ef39b9$export$12b700018201cb9d = Object.freeze([
    0,
    0,
    1,
    0
]);
const $52309310b7ef39b9$export$284056b49bcc0ed1 = Object.freeze([
    0,
    0,
    0,
    1
]);


const $9be5749ead3c448c$export$f6e2535fb5126e54 = (x)=>typeof x === "function";


function $bdafd432e4835a09$export$c7d5ea85f8b34f37(fn, cache = /* @__PURE__ */ Object.create(null)) {
    return (...args)=>{
        const key = JSON.stringify(args);
        if (key !== void 0) return key in cache ? cache[key] : cache[key] = fn.apply(null, args);
        return fn.apply(null, args);
    };
}
function $bdafd432e4835a09$export$a3f97b6995b6ef5e(fn, cache = /* @__PURE__ */ Object.create(null)) {
    return async (...args)=>{
        const key = JSON.stringify(args);
        if (key !== void 0) return key in cache ? cache[key] : cache[key] = await fn.apply(null, args);
        return await fn.apply(null, args);
    };
}


function $ec7fe124e4c4d65f$export$3647141da7a2bad3(fn, cache = /* @__PURE__ */ Object.create(null)) {
    return (...xs)=>{
        const key = xs.join("-");
        return key in cache ? cache[key] : cache[key] = fn(...xs);
    };
}
function $ec7fe124e4c4d65f$export$65a014ca2a9b2e5e(fn, cache = /* @__PURE__ */ Object.create(null)) {
    return async (...xs)=>{
        const key = xs.join("-");
        return key in cache ? cache[key] : cache[key] = await fn(...xs);
    };
}



const $00ac42f39a8e8ff0$export$76d90c956114f2c2 = (0, $ec7fe124e4c4d65f$export$3647141da7a2bad3)((ch, n)=>ch.repeat(n));


const $fbd3ea78a9562deb$export$bc3bea8325045070 = (0, $ec7fe124e4c4d65f$export$3647141da7a2bad3)((n, ch = " ")=>{
    const buf = (0, $00ac42f39a8e8ff0$export$76d90c956114f2c2)(String(ch), n);
    return (x, len)=>{
        if (x == null) return buf;
        x = x.toString();
        len = len !== void 0 ? len : x.length;
        return len < n ? buf.substring(len) + x : x;
    };
});
const $fbd3ea78a9562deb$export$4ef3c22bdc855b90 = $fbd3ea78a9562deb$export$bc3bea8325045070(2, "0");
const $fbd3ea78a9562deb$export$daec30a5ef5beb6b = $fbd3ea78a9562deb$export$bc3bea8325045070(3, "0");
const $fbd3ea78a9562deb$export$12b700018201cb9d = $fbd3ea78a9562deb$export$bc3bea8325045070(4, "0");


const $3334580a33d167c7$export$6b5cd3983e3ee5ab = (0, $bdafd432e4835a09$export$c7d5ea85f8b34f37)((prec, special = false)=>special ? (x)=>$3334580a33d167c7$var$__nanOrInf(x) || x.toFixed(prec) : (x)=>x.toFixed(prec));
const $3334580a33d167c7$export$e22069805c35feb2 = (0, $bdafd432e4835a09$export$c7d5ea85f8b34f37)((width, prec = 3)=>{
    const l = width - prec - 1;
    const pl = Math.pow(10, l);
    const pln = -Math.pow(10, l - 1);
    const pr = Math.pow(10, -(prec - 1));
    const pad = (0, $fbd3ea78a9562deb$export$bc3bea8325045070)(width);
    return (x)=>{
        const ax = Math.abs(x);
        return pad($3334580a33d167c7$var$__nanOrInf(x) || (x === 0 ? "0" : ax < pr || ax >= pl ? $3334580a33d167c7$var$__exp(x, width) : x.toFixed(prec - (x < pln ? 1 : 0))));
    };
});
const $3334580a33d167c7$var$__exp = (x, w)=>x.toExponential(Math.max(w - 4 - (Math.log(Math.abs(x)) / Math.LN10 >= 10 ? 2 : 1) - (x < 0 ? 1 : 0), 0));
const $3334580a33d167c7$var$__nanOrInf = (x)=>isNaN(x) ? "NaN" : x === Infinity ? "+\u221E" : x === -Infinity ? "-\u221E" : void 0;


const $6483359b6c7b9085$export$6abec1377e0e6f1d = (opts = {})=>{
    const { prec: prec = 3, delim: delim = ", ", wrap: wrap = "[]", width: width } = opts;
    const fmt = width ? (0, $3334580a33d167c7$export$e22069805c35feb2)(width, prec) : (0, $3334580a33d167c7$export$6b5cd3983e3ee5ab)(prec);
    return (src)=>{
        let res = [];
        for (const x of src)res.push(fmt(x));
        return `${wrap[0]}${res.join(delim)}${wrap[1]}`;
    };
};
const $6483359b6c7b9085$export$252ba04f1237c8d2 = (fmt)=>{
    $6483359b6c7b9085$export$92cfe806f4f0ae2f = (0, $9be5749ead3c448c$export$f6e2535fb5126e54)(fmt) ? fmt : $6483359b6c7b9085$export$6abec1377e0e6f1d(fmt);
};
let $6483359b6c7b9085$export$92cfe806f4f0ae2f = $6483359b6c7b9085$export$6abec1377e0e6f1d();


class $4bf6e77b6ebf16fb$export$e78ed9e3e9c540e6 {
    buf;
    offset;
    stride;
    constructor(buf, offset = 0, stride = 1){
        this.buf = buf;
        this.offset = offset;
        this.stride = stride;
    }
    toString() {
        return (0, $6483359b6c7b9085$export$92cfe806f4f0ae2f)(this);
    }
}


var $79d471b40a5f3836$export$c486935b7b0b00f7 = /* @__PURE__ */ ((GLType2)=>{
    GLType2[GLType2["I8"] = 5120] = "I8";
    GLType2[GLType2["U8"] = 5121] = "U8";
    GLType2[GLType2["I16"] = 5122] = "I16";
    GLType2[GLType2["U16"] = 5123] = "U16";
    GLType2[GLType2["I32"] = 5124] = "I32";
    GLType2[GLType2["U32"] = 5125] = "U32";
    GLType2[GLType2["F32"] = 5126] = "F32";
    return GLType2;
})($79d471b40a5f3836$export$c486935b7b0b00f7 || {});
const $79d471b40a5f3836$export$7e50410e6851a5db = {
    [5120 /* I8 */ ]: "i8",
    [5121 /* U8 */ ]: "u8",
    [5122 /* I16 */ ]: "i16",
    [5123 /* U16 */ ]: "u16",
    [5124 /* I32 */ ]: "i32",
    [5125 /* U32 */ ]: "u32",
    [5126 /* F32 */ ]: "f32"
};
const $79d471b40a5f3836$export$ccc3907fb755d361 = {
    i8: 5120 /* I8 */ ,
    u8: 5121 /* U8 */ ,
    u8c: 5121 /* U8 */ ,
    i16: 5122 /* I16 */ ,
    u16: 5123 /* U16 */ ,
    i32: 5124 /* I32 */ ,
    u32: 5125 /* U32 */ ,
    f32: 5126 /* F32 */ ,
    f64: void 0
};
const $79d471b40a5f3836$export$77a8a3ec2376cb23 = {
    u8: 1,
    u8c: 1,
    i8: 1,
    u16: 2,
    i16: 2,
    u32: 4,
    i32: 4,
    i64: 8,
    u64: 8,
    f32: 4,
    f64: 8
};
const $79d471b40a5f3836$export$4c68bfc8c9124205 = {
    i8: 0,
    u8: 0,
    u8c: 0,
    i16: 1,
    u16: 1,
    i32: 2,
    u32: 2,
    i64: 3,
    u64: 3,
    f32: 2,
    f64: 3
};
const $79d471b40a5f3836$export$7f91e23c347e83e3 = {
    f32: Float32Array,
    f64: Float64Array
};
const $79d471b40a5f3836$export$62a9a53bce51b47f = {
    i8: Int8Array,
    i16: Int16Array,
    i32: Int32Array
};
const $79d471b40a5f3836$export$89dd89c1ab6a21e0 = {
    u8: Uint8Array,
    u8c: Uint8ClampedArray,
    u16: Uint16Array,
    u32: Uint32Array
};
const $79d471b40a5f3836$export$20fb4bf8497f343f = {
    i64: BigInt64Array,
    u64: BigUint64Array
};
const $79d471b40a5f3836$export$3b381702ed33cf2b = {
    ...$79d471b40a5f3836$export$7f91e23c347e83e3,
    ...$79d471b40a5f3836$export$62a9a53bce51b47f,
    ...$79d471b40a5f3836$export$89dd89c1ab6a21e0
};
const $79d471b40a5f3836$export$afc4952745a9c0bc = (type)=>{
    const t = $79d471b40a5f3836$export$7e50410e6851a5db[type];
    return t !== void 0 ? t : type;
};
const $79d471b40a5f3836$export$44655affa77d94c2 = (type)=>{
    const t = $79d471b40a5f3836$export$ccc3907fb755d361[type];
    return t !== void 0 ? t : type;
};
const $79d471b40a5f3836$export$49ed6a48804688ff = (...args)=>args.map((x)=>x | 0);
const $79d471b40a5f3836$export$30043de3fae42dd1 = (type)=>$79d471b40a5f3836$export$77a8a3ec2376cb23[type] || $79d471b40a5f3836$export$77a8a3ec2376cb23[$79d471b40a5f3836$export$afc4952745a9c0bc(type)];
function $79d471b40a5f3836$export$ee441149f193b45a(type, ...args) {
    const ctor = $79d471b40a5f3836$export$20fb4bf8497f343f[type];
    return new (ctor || $79d471b40a5f3836$export$3b381702ed33cf2b[$79d471b40a5f3836$export$afc4952745a9c0bc(type)])(...args);
}
function $79d471b40a5f3836$export$8aa2910912d5a0d6(type, data, stride) {
    const $data = Array.isArray(data) ? data : [
        ...data
    ];
    if (stride === void 0) stride = $data[0].length;
    const num = $data.length;
    const res = $79d471b40a5f3836$export$ee441149f193b45a(type, num * stride);
    for(let i = 0, j = 0; i < num; i++, j += stride)res.set($data[i], j);
    return res;
}
const $79d471b40a5f3836$export$3c3c83d33ac519a3 = (x)=>{
    if (Array.isArray(x)) return "f64";
    for(const id in $79d471b40a5f3836$export$3b381702ed33cf2b){
        if (x instanceof $79d471b40a5f3836$export$3b381702ed33cf2b[id]) return id;
    }
    return "f64";
};
const $79d471b40a5f3836$export$1ef41013d4af1773 = (x)=>x <= 256 ? "u8" : x <= 65536 ? "u16" : "u32";
const $79d471b40a5f3836$export$32d1ef3a1ec2b22 = (x)=>x >= -128 && x < 128 ? "i8" : x >= -32768 && x < 32768 ? "i16" : "i32";
const $79d471b40a5f3836$export$febce5e071c36869 = (x)=>x > 16 ? "u32" : x > 8 ? "u16" : "u8";
const $79d471b40a5f3836$export$71cc2d6d50aeb7db = (x)=>x > 16 ? "i32" : x > 8 ? "i16" : "i8";
const $79d471b40a5f3836$export$5bf18276ad35cd3e = (t)=>t === "i64" ? "i32" : t === "i32" ? "i16" : t === "i16" ? "i8" : "i8";
const $79d471b40a5f3836$export$4f99611726c808da = (t)=>t === "i8" ? "i16" : t === "i16" ? "i32" : t === "i32" ? "i64" : "i64";
const $79d471b40a5f3836$export$8e455a4b51a8bb3f = (t)=>t === "u64" ? "u32" : t === "u32" ? "u16" : t === "u16" ? "u8" : "u8";
const $79d471b40a5f3836$export$1fad4022ed34f5c9 = (t)=>t === "u8" || t === "u8c" ? "u16" : t === "u16" ? "u32" : t === "u32" ? "u64" : "u64";
const $79d471b40a5f3836$export$45ae02d96eef78a7 = (t)=>t === "f64" ? "f32" : "f32";
const $79d471b40a5f3836$export$aa2b6251594b2509 = (t)=>t === "f32" ? "f64" : "f64";
const $79d471b40a5f3836$export$d3dad6665afedd1 = (t)=>t[0] === "i" ? $79d471b40a5f3836$export$5bf18276ad35cd3e(t) : t[0] === "u" ? $79d471b40a5f3836$export$8e455a4b51a8bb3f(t) : $79d471b40a5f3836$export$45ae02d96eef78a7(t);
const $79d471b40a5f3836$export$719ac81e6c2c015 = (t)=>t[0] === "i" ? $79d471b40a5f3836$export$4f99611726c808da(t) : t[0] === "u" ? $79d471b40a5f3836$export$1fad4022ed34f5c9(t) : $79d471b40a5f3836$export$aa2b6251594b2509(t);


const $facda38a6394ffc8$export$9b6f948535b77d53 = (type, buf, num, size, byteOffset = 0, byteStride = size * (0, $79d471b40a5f3836$export$77a8a3ec2376cb23)[type])=>{
    const res = [];
    for(; num-- > 0; byteOffset += byteStride)res.push((0, $79d471b40a5f3836$export$ee441149f193b45a)(type, buf, byteOffset, size));
    return res;
};
const $facda38a6394ffc8$export$90b90ea32db1a99a = (type, buf, src, byteOffset, byteStride)=>{
    const view = (0, $79d471b40a5f3836$export$ee441149f193b45a)(type, buf);
    const size = (0, $79d471b40a5f3836$export$77a8a3ec2376cb23)[type];
    byteOffset /= size;
    byteStride /= size;
    for (const x of src){
        view.set(x, byteOffset);
        byteOffset += byteStride;
    }
};
const $facda38a6394ffc8$export$e9242f670cb20645 = (ctor, buf, num, start, cstride, estride)=>{
    const res = [];
    while(num-- > 0){
        res.push(new ctor(buf, start, cstride));
        start += estride;
    }
    return res;
};
const $facda38a6394ffc8$export$1d55c56b05a9e712 = (set, buf, src, start, cstride, estride)=>{
    for (const v of src){
        set(buf, v, start, 0, cstride, 1);
        start += estride;
    }
    return buf;
};




const $a9427a2d35d466b4$var$abs = Math.abs;
const $a9427a2d35d466b4$var$max = Math.max;
const $a9427a2d35d466b4$export$3e1b8005eb6f3d68 = (a, b, eps = (0, $de6ddf51c250e19d$export$56469a43a57ad8b6))=>$a9427a2d35d466b4$var$abs(a - b) <= eps;
const $a9427a2d35d466b4$export$9dc0cc51b6ffc288 = (a, b, eps = (0, $de6ddf51c250e19d$export$56469a43a57ad8b6))=>$a9427a2d35d466b4$var$abs(a - b) <= eps * $a9427a2d35d466b4$var$max(1, $a9427a2d35d466b4$var$abs(a), $a9427a2d35d466b4$var$abs(b));


const $ed8fc9c7ad92fdc8$export$c915e14294a7d06f = (x, fn)=>typeof x?.[fn] === "function";


const $980af67c4a4518af$export$651a6eb01ea522f3 = (prefix, suffix = (msg)=>msg !== void 0 ? ": " + msg : "")=>class extends Error {
        origMessage;
        constructor(msg){
            super(prefix(msg) + suffix(msg));
            this.origMessage = msg !== void 0 ? String(msg) : "";
        }
    };


const $ae7423d3acb6cda2$export$ab59e00737fb22e6 = (0, $980af67c4a4518af$export$651a6eb01ea522f3)(()=>"unsupported operation");
const $ae7423d3acb6cda2$export$823cb463902851f8 = (msg)=>{
    throw new $ae7423d3acb6cda2$export$ab59e00737fb22e6(msg);
};
const $ae7423d3acb6cda2$export$98e633703a635f = $ae7423d3acb6cda2$export$823cb463902851f8;
const $ae7423d3acb6cda2$export$bd0820eb8444fcd9 = (0, $980af67c4a4518af$export$651a6eb01ea522f3)(()=>"unsupported feature");
const $ae7423d3acb6cda2$export$606d4ef5131f315c = (msg)=>{
    throw new $ae7423d3acb6cda2$export$bd0820eb8444fcd9(msg);
};


const $1b0089e3705a02bc$export$c37d18c23b2ea60c = (dispatch = 1, fallback, ...optimized)=>{
    const impls = [
        ,
        , 
    ].concat(optimized);
    const fn = (...args)=>{
        const g = impls[args[dispatch].length] || fallback;
        return g ? g(...args) : (0, $ae7423d3acb6cda2$export$823cb463902851f8)(`no impl for vec size ${args[dispatch].length}`);
    };
    fn.add = (dim, fn2)=>impls[dim] = fn2;
    fn.default = (fn2)=>fallback = fn2;
    fn.impl = (dim)=>dim != null ? impls[dim] || fallback : fallback;
    return fn;
};


const $9b03fa9ab763bd7d$export$c63d26dbbb7a5033 = (a, b, eps = (0, $de6ddf51c250e19d$export$56469a43a57ad8b6))=>{
    return a.length === b.length && (0, $a9427a2d35d466b4$export$3e1b8005eb6f3d68)(a[0], b[0], eps) && (0, $a9427a2d35d466b4$export$3e1b8005eb6f3d68)(a[1], b[1], eps);
};
const $9b03fa9ab763bd7d$export$819cb4b1ecd374c5 = (a, b, eps = (0, $de6ddf51c250e19d$export$56469a43a57ad8b6))=>{
    return a.length === b.length && (0, $a9427a2d35d466b4$export$3e1b8005eb6f3d68)(a[0], b[0], eps) && (0, $a9427a2d35d466b4$export$3e1b8005eb6f3d68)(a[1], b[1], eps) && (0, $a9427a2d35d466b4$export$3e1b8005eb6f3d68)(a[2], b[2], eps);
};
const $9b03fa9ab763bd7d$export$215c4845217d5cf1 = (a, b, eps = (0, $de6ddf51c250e19d$export$56469a43a57ad8b6))=>{
    return a.length === b.length && (0, $a9427a2d35d466b4$export$3e1b8005eb6f3d68)(a[0], b[0], eps) && (0, $a9427a2d35d466b4$export$3e1b8005eb6f3d68)(a[1], b[1], eps) && (0, $a9427a2d35d466b4$export$3e1b8005eb6f3d68)(a[2], b[2], eps) && (0, $a9427a2d35d466b4$export$3e1b8005eb6f3d68)(a[3], b[3], eps);
};
const $9b03fa9ab763bd7d$export$3e1b8005eb6f3d68 = (0, $1b0089e3705a02bc$export$c37d18c23b2ea60c)(0, (v1, v2, eps = (0, $de6ddf51c250e19d$export$56469a43a57ad8b6))=>{
    if ((0, $ed8fc9c7ad92fdc8$export$c915e14294a7d06f)(v1, "eqDelta")) return v1.eqDelta(v2, eps);
    if ((0, $ed8fc9c7ad92fdc8$export$c915e14294a7d06f)(v2, "eqDelta")) return v2.eqDelta(v1, eps);
    return $9b03fa9ab763bd7d$export$75f4a8c48213224e(v1, v2, v1.length, eps);
}, $9b03fa9ab763bd7d$export$c63d26dbbb7a5033, $9b03fa9ab763bd7d$export$819cb4b1ecd374c5, $9b03fa9ab763bd7d$export$215c4845217d5cf1);
const $9b03fa9ab763bd7d$export$75f4a8c48213224e = (a, b, n, eps = (0, $de6ddf51c250e19d$export$56469a43a57ad8b6), ia = 0, ib = 0, sa = 1, sb = 1)=>{
    for(; n > 0; n--, ia += sa, ib += sb){
        if (!(0, $a9427a2d35d466b4$export$3e1b8005eb6f3d68)(a[ia], b[ib], eps)) return false;
    }
    return true;
};
const $9b03fa9ab763bd7d$export$ae8a06ab824e4b05 = (a, b, eps = (0, $de6ddf51c250e19d$export$56469a43a57ad8b6))=>{
    if (a === b) return true;
    if (a.length !== b.length) return false;
    for(let i = a.length; i-- > 0;){
        if (!$9b03fa9ab763bd7d$export$3e1b8005eb6f3d68(a[i], b[i], eps)) return false;
    }
    return true;
};
const $9b03fa9ab763bd7d$export$5e9bb4359042e24b = (p, pts, eps = (0, $de6ddf51c250e19d$export$56469a43a57ad8b6))=>{
    for(let i = pts.length; i-- > 0;){
        if ($9b03fa9ab763bd7d$export$3e1b8005eb6f3d68(p, pts[i], eps)) return true;
    }
    return false;
};


const $844368e17e694fd3$export$b820c9ce995741f7 = new Float64Array(1);
const $844368e17e694fd3$export$7f31fea5c026b8b1 = new Float32Array($844368e17e694fd3$export$b820c9ce995741f7.buffer);
const $844368e17e694fd3$export$917d0f0bbc9295da = new Int8Array($844368e17e694fd3$export$b820c9ce995741f7.buffer);
const $844368e17e694fd3$export$b85f1fec329875bb = new Uint8Array($844368e17e694fd3$export$b820c9ce995741f7.buffer);
const $844368e17e694fd3$export$448662de1558f8ff = new Int16Array($844368e17e694fd3$export$b820c9ce995741f7.buffer);
const $844368e17e694fd3$export$a3d4e5b5a9aac813 = new Uint16Array($844368e17e694fd3$export$b820c9ce995741f7.buffer);
const $844368e17e694fd3$export$6ba3a1029e89322c = new Int32Array($844368e17e694fd3$export$b820c9ce995741f7.buffer);
const $844368e17e694fd3$export$70e00273ab09d5a4 = new Uint32Array($844368e17e694fd3$export$b820c9ce995741f7.buffer);
const $844368e17e694fd3$export$5a031e8bdf2570e9 = new BigInt64Array($844368e17e694fd3$export$b820c9ce995741f7.buffer);
const $844368e17e694fd3$export$cd3a2639ae8247c3 = new BigUint64Array($844368e17e694fd3$export$b820c9ce995741f7.buffer);


const $111a78a6cd8de433$export$6a2795cb7ee83288 = ((0, $844368e17e694fd3$export$70e00273ab09d5a4)[0] = 1, (0, $844368e17e694fd3$export$b85f1fec329875bb)[0] === 1);
const $111a78a6cd8de433$export$df134c112ed729b4 = {
    getI8: (src, i)=>((0, $844368e17e694fd3$export$917d0f0bbc9295da)[0] = src[i], (0, $844368e17e694fd3$export$917d0f0bbc9295da)[0]),
    getU8: (src, i)=>src[i] & 255,
    getI16: (src, i, isLE)=>$111a78a6cd8de433$var$__get2(src, i, (0, $844368e17e694fd3$export$448662de1558f8ff), isLE),
    getU16: (src, i, isLE)=>$111a78a6cd8de433$var$__get2(src, i, (0, $844368e17e694fd3$export$a3d4e5b5a9aac813), isLE),
    getI32: (src, i, isLE)=>$111a78a6cd8de433$var$__get4(src, i, (0, $844368e17e694fd3$export$6ba3a1029e89322c), isLE),
    getU32: (src, i, isLE)=>$111a78a6cd8de433$var$__get4(src, i, (0, $844368e17e694fd3$export$70e00273ab09d5a4), isLE) >>> 0,
    getI64: (src, i, isLE)=>$111a78a6cd8de433$var$__get8(src, i, (0, $844368e17e694fd3$export$5a031e8bdf2570e9), isLE),
    getU64: (src, i, isLE)=>$111a78a6cd8de433$var$__get8(src, i, (0, $844368e17e694fd3$export$cd3a2639ae8247c3), isLE),
    getF32: (src, i, isLE)=>$111a78a6cd8de433$var$__get4(src, i, (0, $844368e17e694fd3$export$7f31fea5c026b8b1), isLE),
    getF64: (src, i, isLE)=>$111a78a6cd8de433$var$__get8(src, i, (0, $844368e17e694fd3$export$b820c9ce995741f7), isLE),
    setI8: (data, addr, x)=>{
        (0, $844368e17e694fd3$export$917d0f0bbc9295da)[0] = x;
        data[addr] = (0, $844368e17e694fd3$export$b85f1fec329875bb)[0];
    },
    setU8: (data, addr, x)=>{
        data[addr] = x & 255;
    },
    setI16: (data, addr, x, isLE)=>{
        (0, $844368e17e694fd3$export$448662de1558f8ff)[0] = x;
        $111a78a6cd8de433$var$__set2(data, addr, isLE);
    },
    setU16: (data, addr, x, isLE)=>{
        (0, $844368e17e694fd3$export$a3d4e5b5a9aac813)[0] = x;
        $111a78a6cd8de433$var$__set2(data, addr, isLE);
    },
    setI32: (data, addr, x, isLE)=>{
        (0, $844368e17e694fd3$export$6ba3a1029e89322c)[0] = x;
        $111a78a6cd8de433$var$__set4(data, addr, isLE);
    },
    setU32: (data, addr, x, isLE)=>{
        (0, $844368e17e694fd3$export$70e00273ab09d5a4)[0] = x;
        $111a78a6cd8de433$var$__set4(data, addr, isLE);
    },
    setF32: (data, addr, x, isLE)=>{
        (0, $844368e17e694fd3$export$7f31fea5c026b8b1)[0] = x;
        $111a78a6cd8de433$var$__set4(data, addr, isLE);
    },
    setF64: (data, addr, x, isLE)=>{
        (0, $844368e17e694fd3$export$b820c9ce995741f7)[0] = x;
        $111a78a6cd8de433$var$__set8(data, addr, isLE);
    },
    setI64: (data, addr, x, isLE)=>{
        (0, $844368e17e694fd3$export$5a031e8bdf2570e9)[0] = x;
        $111a78a6cd8de433$var$__set8(data, addr, isLE);
    },
    setU64: (data, addr, x, isLE)=>{
        (0, $844368e17e694fd3$export$cd3a2639ae8247c3)[0] = x;
        $111a78a6cd8de433$var$__set8(data, addr, isLE);
    }
};
const $111a78a6cd8de433$var$__get2 = (src, i, view, isLE = true)=>isLE !== $111a78a6cd8de433$export$6a2795cb7ee83288 ? ((0, $844368e17e694fd3$export$b85f1fec329875bb)[1] = src[i], (0, $844368e17e694fd3$export$b85f1fec329875bb)[0] = src[i + 1], view[0]) : ((0, $844368e17e694fd3$export$b85f1fec329875bb)[0] = src[i], (0, $844368e17e694fd3$export$b85f1fec329875bb)[1] = src[i + 1], view[0]);
const $111a78a6cd8de433$var$__get4 = (src, i, view, isLE = true)=>isLE !== $111a78a6cd8de433$export$6a2795cb7ee83288 ? ((0, $844368e17e694fd3$export$b85f1fec329875bb)[3] = src[i], (0, $844368e17e694fd3$export$b85f1fec329875bb)[2] = src[i + 1], (0, $844368e17e694fd3$export$b85f1fec329875bb)[1] = src[i + 2], (0, $844368e17e694fd3$export$b85f1fec329875bb)[0] = src[i + 3], view[0]) : ((0, $844368e17e694fd3$export$b85f1fec329875bb)[0] = src[i], (0, $844368e17e694fd3$export$b85f1fec329875bb)[1] = src[i + 1], (0, $844368e17e694fd3$export$b85f1fec329875bb)[2] = src[i + 2], (0, $844368e17e694fd3$export$b85f1fec329875bb)[3] = src[i + 3], view[0]);
const $111a78a6cd8de433$var$__get8 = (src, i, view, isLE = true)=>isLE !== $111a78a6cd8de433$export$6a2795cb7ee83288 ? ((0, $844368e17e694fd3$export$b85f1fec329875bb)[7] = src[i], (0, $844368e17e694fd3$export$b85f1fec329875bb)[6] = src[i + 1], (0, $844368e17e694fd3$export$b85f1fec329875bb)[5] = src[i + 2], (0, $844368e17e694fd3$export$b85f1fec329875bb)[4] = src[i + 3], (0, $844368e17e694fd3$export$b85f1fec329875bb)[3] = src[i + 4], (0, $844368e17e694fd3$export$b85f1fec329875bb)[2] = src[i + 5], (0, $844368e17e694fd3$export$b85f1fec329875bb)[1] = src[i + 6], (0, $844368e17e694fd3$export$b85f1fec329875bb)[0] = src[i + 7], view[0]) : ((0, $844368e17e694fd3$export$b85f1fec329875bb)[0] = src[i], (0, $844368e17e694fd3$export$b85f1fec329875bb)[1] = src[i + 1], (0, $844368e17e694fd3$export$b85f1fec329875bb)[2] = src[i + 2], (0, $844368e17e694fd3$export$b85f1fec329875bb)[3] = src[i + 3], (0, $844368e17e694fd3$export$b85f1fec329875bb)[4] = src[i + 4], (0, $844368e17e694fd3$export$b85f1fec329875bb)[5] = src[i + 5], (0, $844368e17e694fd3$export$b85f1fec329875bb)[6] = src[i + 6], (0, $844368e17e694fd3$export$b85f1fec329875bb)[7] = src[i + 7], view[0]);
const $111a78a6cd8de433$var$__set2 = (data, addr, isLE = true)=>{
    if (isLE !== $111a78a6cd8de433$export$6a2795cb7ee83288) {
        data[addr] = (0, $844368e17e694fd3$export$b85f1fec329875bb)[1];
        data[addr + 1] = (0, $844368e17e694fd3$export$b85f1fec329875bb)[0];
    } else {
        data[addr] = (0, $844368e17e694fd3$export$b85f1fec329875bb)[0];
        data[addr + 1] = (0, $844368e17e694fd3$export$b85f1fec329875bb)[1];
    }
};
const $111a78a6cd8de433$var$__set4 = (data, addr, isLE = true)=>{
    if (isLE !== $111a78a6cd8de433$export$6a2795cb7ee83288) {
        data[addr] = (0, $844368e17e694fd3$export$b85f1fec329875bb)[3];
        data[addr + 1] = (0, $844368e17e694fd3$export$b85f1fec329875bb)[2];
        data[addr + 2] = (0, $844368e17e694fd3$export$b85f1fec329875bb)[1];
        data[addr + 3] = (0, $844368e17e694fd3$export$b85f1fec329875bb)[0];
    } else {
        data[addr] = (0, $844368e17e694fd3$export$b85f1fec329875bb)[0];
        data[addr + 1] = (0, $844368e17e694fd3$export$b85f1fec329875bb)[1];
        data[addr + 2] = (0, $844368e17e694fd3$export$b85f1fec329875bb)[2];
        data[addr + 3] = (0, $844368e17e694fd3$export$b85f1fec329875bb)[3];
    }
};
const $111a78a6cd8de433$var$__set8 = (data, addr, isLE = true)=>{
    if (isLE !== $111a78a6cd8de433$export$6a2795cb7ee83288) {
        data[addr] = (0, $844368e17e694fd3$export$b85f1fec329875bb)[7];
        data[addr + 1] = (0, $844368e17e694fd3$export$b85f1fec329875bb)[6];
        data[addr + 2] = (0, $844368e17e694fd3$export$b85f1fec329875bb)[5];
        data[addr + 3] = (0, $844368e17e694fd3$export$b85f1fec329875bb)[4];
        data[addr + 4] = (0, $844368e17e694fd3$export$b85f1fec329875bb)[3];
        data[addr + 5] = (0, $844368e17e694fd3$export$b85f1fec329875bb)[2];
        data[addr + 6] = (0, $844368e17e694fd3$export$b85f1fec329875bb)[1];
        data[addr + 7] = (0, $844368e17e694fd3$export$b85f1fec329875bb)[0];
    } else {
        data[addr] = (0, $844368e17e694fd3$export$b85f1fec329875bb)[0];
        data[addr + 1] = (0, $844368e17e694fd3$export$b85f1fec329875bb)[1];
        data[addr + 2] = (0, $844368e17e694fd3$export$b85f1fec329875bb)[2];
        data[addr + 3] = (0, $844368e17e694fd3$export$b85f1fec329875bb)[3];
        data[addr + 4] = (0, $844368e17e694fd3$export$b85f1fec329875bb)[4];
        data[addr + 5] = (0, $844368e17e694fd3$export$b85f1fec329875bb)[5];
        data[addr + 6] = (0, $844368e17e694fd3$export$b85f1fec329875bb)[6];
        data[addr + 7] = (0, $844368e17e694fd3$export$b85f1fec329875bb)[7];
    }
};



const $57a46b69e0f70d68$export$f2c6f692120701d0 = (x)=>((0, $844368e17e694fd3$export$7f31fea5c026b8b1)[0] = x, (0, $844368e17e694fd3$export$6ba3a1029e89322c)[0]);
const $57a46b69e0f70d68$export$e465f441695c7ee5 = (x)=>((0, $844368e17e694fd3$export$7f31fea5c026b8b1)[0] = x, (0, $844368e17e694fd3$export$70e00273ab09d5a4)[0]);
const $57a46b69e0f70d68$export$6788b7959a6790be = (x)=>((0, $844368e17e694fd3$export$6ba3a1029e89322c)[0] = x, (0, $844368e17e694fd3$export$7f31fea5c026b8b1)[0]);
const $57a46b69e0f70d68$export$a1b71ebe4ff7c638 = (x)=>((0, $844368e17e694fd3$export$70e00273ab09d5a4)[0] = x, (0, $844368e17e694fd3$export$7f31fea5c026b8b1)[0]);
const $57a46b69e0f70d68$export$3a1da5c8f0be62e = (x)=>((0, $844368e17e694fd3$export$b820c9ce995741f7)[0] = x, (0, $111a78a6cd8de433$export$6a2795cb7ee83288) ? [
        (0, $844368e17e694fd3$export$6ba3a1029e89322c)[1],
        (0, $844368e17e694fd3$export$6ba3a1029e89322c)[0]
    ] : [
        (0, $844368e17e694fd3$export$6ba3a1029e89322c)[0],
        (0, $844368e17e694fd3$export$6ba3a1029e89322c)[1]
    ]);
const $57a46b69e0f70d68$export$168982b015bbc17e = (x)=>((0, $844368e17e694fd3$export$b820c9ce995741f7)[0] = x, (0, $111a78a6cd8de433$export$6a2795cb7ee83288) ? [
        (0, $844368e17e694fd3$export$70e00273ab09d5a4)[1],
        (0, $844368e17e694fd3$export$70e00273ab09d5a4)[0]
    ] : [
        (0, $844368e17e694fd3$export$70e00273ab09d5a4)[0],
        (0, $844368e17e694fd3$export$70e00273ab09d5a4)[1]
    ]);
const $57a46b69e0f70d68$export$d88f93a55e47d37b = (hi, lo)=>{
    (0, $111a78a6cd8de433$export$6a2795cb7ee83288) ? ((0, $844368e17e694fd3$export$6ba3a1029e89322c)[1] = hi, (0, $844368e17e694fd3$export$6ba3a1029e89322c)[0] = lo) : ((0, $844368e17e694fd3$export$6ba3a1029e89322c)[0] = hi, (0, $844368e17e694fd3$export$6ba3a1029e89322c)[1] = lo);
    return (0, $844368e17e694fd3$export$b820c9ce995741f7)[0];
};
const $57a46b69e0f70d68$export$4d58946f20823572 = (hi, lo)=>{
    (0, $111a78a6cd8de433$export$6a2795cb7ee83288) ? ((0, $844368e17e694fd3$export$70e00273ab09d5a4)[1] = hi, (0, $844368e17e694fd3$export$70e00273ab09d5a4)[0] = lo) : ((0, $844368e17e694fd3$export$70e00273ab09d5a4)[0] = hi, (0, $844368e17e694fd3$export$70e00273ab09d5a4)[1] = lo);
    return (0, $844368e17e694fd3$export$b820c9ce995741f7)[0];
};
const $57a46b69e0f70d68$export$20fdeb2128e908a0 = (x)=>{
    if (x === 0) return 0;
    const i = $57a46b69e0f70d68$export$f2c6f692120701d0(x);
    return x < 0 ? ~i | -2147483648 : i;
};
const $57a46b69e0f70d68$var$__f2u = (x, n, p)=>x < 0 ? x < -1 ? n : x * n : x > 1 ? p : x * p;
const $57a46b69e0f70d68$export$542986f3ea145ead = (x)=>$57a46b69e0f70d68$var$__f2u(x, 128, 127) & 255;
const $57a46b69e0f70d68$export$b0fdae4a68085a71 = (x)=>$57a46b69e0f70d68$var$__f2u(x, 32768, 32767) & 65535;
const $57a46b69e0f70d68$export$a31e3bf07bc9e334 = (x)=>$57a46b69e0f70d68$var$__f2u(x, 8388608, 8388607) & 16777215;
const $57a46b69e0f70d68$export$fc300ea7a613d7c8 = (x)=>$57a46b69e0f70d68$var$__f2u(x, 2147483648, 2147483647) >>> 0;
const $57a46b69e0f70d68$export$6645402cbdf92c3d = (x)=>(x &= 255, (x | (x >> 7) * 4294967040) / (127 + (x >> 7)));
const $57a46b69e0f70d68$export$e9f24a18f044f81a = (x)=>(x &= 65535, (x | (x >> 15) * 4294901760) / (32767 + (x >> 15)));
const $57a46b69e0f70d68$export$6199ac7d497f9170 = (x)=>(x &= 16777215, (x | (x >> 23) * 4278190080) / (8388607 + (x >> 23)));
const $57a46b69e0f70d68$export$4e34a1ba89dc20ad = (x)=>(x | 0) / (2147483647 + (x >>> 31));


const $b63b35bcb6dab7af$export$c5ff7c6cb12f5f46 = (x, n)=>(x << n | x >>> 32 - n) >>> 0;
const $b63b35bcb6dab7af$export$b8ff662d454dbe46 = (x, n)=>(x >>> n | x << 32 - n) >>> 0;
const $b63b35bcb6dab7af$export$f4b5465a1b117e52 = (x, n)=>n < 0 ? x << -n : x >>> n;


const $8162b7557a95570f$var$imul = Math.imul;
const $8162b7557a95570f$export$d6af199866bfb566 = (v, H = 2654435761)=>{
    let hash4 = -1;
    for(let i = v.length; i-- > 0;)hash4 = $8162b7557a95570f$var$imul(H, hash4) + $8162b7557a95570f$var$__mix(hash4, (0, $57a46b69e0f70d68$export$e465f441695c7ee5)(v[i])) >>> 0;
    return hash4;
};
const $8162b7557a95570f$var$M1 = 3432918353;
const $8162b7557a95570f$var$M2 = 461845907;
const $8162b7557a95570f$var$M3 = 3864292196;
const $8162b7557a95570f$var$__mix = (h, k)=>{
    k = $8162b7557a95570f$var$imul((0, $b63b35bcb6dab7af$export$c5ff7c6cb12f5f46)($8162b7557a95570f$var$imul(k, $8162b7557a95570f$var$M1) >>> 0, 15), $8162b7557a95570f$var$M2) >>> 0;
    return ($8162b7557a95570f$var$imul((0, $b63b35bcb6dab7af$export$c5ff7c6cb12f5f46)(h ^ k, 13), 5) >>> 0) + $8162b7557a95570f$var$M3 >>> 0;
};
const $8162b7557a95570f$export$5c1364a3a3dcca9f = (x, y)=>($8162b7557a95570f$var$imul(x, $8162b7557a95570f$var$M1) ^ $8162b7557a95570f$var$imul(y, $8162b7557a95570f$var$M3)) >>> 0;
const $8162b7557a95570f$export$e8252014c7caf648 = (x, y, z)=>($8162b7557a95570f$var$imul(x, $8162b7557a95570f$var$M1) ^ $8162b7557a95570f$var$imul(y, $8162b7557a95570f$var$M2) ^ $8162b7557a95570f$var$imul(z, $8162b7557a95570f$var$M3)) >>> 0;


function* $f498be4f76afdb70$export$b67c4b3d8ab4ccaf(ctor, buf, num, start, cstride, estride) {
    while(num-- > 0){
        yield new ctor(buf, start, cstride);
        start += estride;
    }
}
function* $f498be4f76afdb70$export$de7c8d5f4bf654ca(buf, num, start, stride) {
    while(num-- > 0){
        yield buf[start];
        start += stride;
    }
}


const $d22d6ea0e6491af6$export$b1681e55aa41cf93 = (o, a, size, io = 0, ia = 0, so = 1, sa = 1)=>{
    !o && (o = []);
    while(size-- > 0)o[io + size * so] = a[ia + size * sa];
    return o;
};
const $d22d6ea0e6491af6$export$ce03ce82183fcacf = (o, a, io = 0, ia = 0, so = 1, sa = 1)=>{
    !o && (o = []);
    o[io] = a[ia];
    o[io + so] = a[ia + sa];
    return o;
};
const $d22d6ea0e6491af6$export$fce72d6f58f3bf47 = (o, a, io = 0, ia = 0, so = 1, sa = 1)=>{
    !o && (o = []);
    o[io] = a[ia];
    o[io + so] = a[ia + sa];
    o[io + 2 * so] = a[ia + 2 * sa];
    return o;
};
const $d22d6ea0e6491af6$export$cbb07426a95117ea = (o, a, io = 0, ia = 0, so = 1, sa = 1)=>{
    !o && (o = []);
    o[io] = a[ia];
    o[io + so] = a[ia + sa];
    o[io + 2 * so] = a[ia + 2 * sa];
    o[io + 3 * so] = a[ia + 3 * sa];
    return o;
};


class $79cb68d57182f57f$export$ac4bca90992eed1 extends (0, $4bf6e77b6ebf16fb$export$e78ed9e3e9c540e6) {
    /**
   * Returns array of memory mapped {@link Vec2} instances using given
   * backing array and stride settings: The `cstride` is the step size
   * between individual XY vector components. `estride` is the step
   * size between successive vectors. This arrangement allows for
   * different storage approaches, incl. SOA, AOS, striped /
   * interleaved etc.
   *
   * @param buf - backing array
   * @param num - num vectors
   * @param start -  start index
   * @param cstride - component stride
   * @param estride - element stride
   */ static mapBuffer(buf, num = buf.length >> 1, start = 0, cstride = 1, estride = 2) {
        return (0, $facda38a6394ffc8$export$e9242f670cb20645)($79cb68d57182f57f$export$ac4bca90992eed1, buf, num, start, cstride, estride);
    }
    /**
   * Merges given `src` iterable of {@link Vec2}s into single array `buf`.
   * Vectors will be arranged according to given component and element
   * strides, starting at `start` index. It's the user's
   * responsibility to ensure the target buffer has sufficient
   * capacity to hold the input vectors. See `Vec2.mapBuffer` for the
   * inverse operation. Returns `buf`.
   *
   * @param buf -
   * @param src -
   * @param start -
   * @param cstride -
   * @param estride -
   */ static intoBuffer(buf, src, start = 0, cstride = 1, estride = 2) {
        return (0, $facda38a6394ffc8$export$1d55c56b05a9e712)((0, $d22d6ea0e6491af6$export$ce03ce82183fcacf), buf, src, start, cstride, estride);
    }
    static iterator(buf, num, start = 0, cstride = 1, estride = 2) {
        return (0, $f498be4f76afdb70$export$b67c4b3d8ab4ccaf)($79cb68d57182f57f$export$ac4bca90992eed1, buf, num, start, cstride, estride);
    }
    static X_AXIS = new $79cb68d57182f57f$export$ac4bca90992eed1((0, $52309310b7ef39b9$export$3d76695dcdb4727a));
    static Y_AXIS = new $79cb68d57182f57f$export$ac4bca90992eed1((0, $52309310b7ef39b9$export$2f0e6bc49da0388c));
    static MIN = new $79cb68d57182f57f$export$ac4bca90992eed1((0, $52309310b7ef39b9$export$df24318f7b7a47df));
    static MAX = new $79cb68d57182f57f$export$ac4bca90992eed1((0, $52309310b7ef39b9$export$d0ebc6d8df6f38f1));
    static ZERO = new $79cb68d57182f57f$export$ac4bca90992eed1((0, $52309310b7ef39b9$export$c2fad5ac839d6a20));
    static ONE = new $79cb68d57182f57f$export$ac4bca90992eed1((0, $52309310b7ef39b9$export$b07c55cad352613c));
    constructor(buf, offset = 0, stride = 1){
        super(buf || [
            0,
            0
        ], offset, stride);
    }
    [Symbol.iterator]() {
        return (0, $f498be4f76afdb70$export$de7c8d5f4bf654ca)(this.buf, 2, this.offset, this.stride);
    }
    get length() {
        return 2;
    }
    get [0]() {
        return this.buf[this.offset];
    }
    set [0](x) {
        this.buf[this.offset] = x;
    }
    get [1]() {
        return this.buf[this.offset + this.stride];
    }
    set [1](y) {
        this.buf[this.offset + this.stride] = y;
    }
    get x() {
        return this.buf[this.offset];
    }
    set x(x) {
        this.buf[this.offset] = x;
    }
    get y() {
        return this.buf[this.offset + this.stride];
    }
    set y(y) {
        this.buf[this.offset + this.stride] = y;
    }
    copy() {
        return new $79cb68d57182f57f$export$ac4bca90992eed1([
            this.x,
            this.y
        ]);
    }
    copyView() {
        return new $79cb68d57182f57f$export$ac4bca90992eed1(this.buf, this.offset, this.stride);
    }
    empty() {
        return new $79cb68d57182f57f$export$ac4bca90992eed1();
    }
    eqDelta(v, eps = (0, $de6ddf51c250e19d$export$56469a43a57ad8b6)) {
        return (0, $9b03fa9ab763bd7d$export$c63d26dbbb7a5033)(this, v, eps);
    }
    hash() {
        return (0, $8162b7557a95570f$export$d6af199866bfb566)(this);
    }
    toJSON() {
        return [
            this.x,
            this.y
        ];
    }
}
const $79cb68d57182f57f$export$e9830bc863290a54 = (x = 0, y = 0)=>new $79cb68d57182f57f$export$ac4bca90992eed1([
        x,
        y
    ]);
const $79cb68d57182f57f$export$9e2a5b31ca3997f2 = (n)=>new $79cb68d57182f57f$export$ac4bca90992eed1([
        n,
        n
    ]);
const $79cb68d57182f57f$export$3733d0c1f7322831 = (x)=>x instanceof $79cb68d57182f57f$export$ac4bca90992eed1 ? x : new $79cb68d57182f57f$export$ac4bca90992eed1(x.length >= 2 ? x : [
        x[0] || 0,
        x[1] || 0
    ]);


const $2ff6d5521fe92bed$export$74e86b495c467255 = (op, dispatch = 1)=>{
    const a = (o, a2, n)=>{
        !o && (o = a2);
        for(let i = a2.length; i-- > 0;)o[i] = op(a2[i], n);
        return o;
    };
    const b = (o, a2, n)=>{
        !o && (o = a2);
        o[0] = op(a2[0], n);
        o[1] = op(a2[1], n);
        return o;
    };
    const c = (o, a2, n)=>{
        !o && (o = a2);
        o[0] = op(a2[0], n);
        o[1] = op(a2[1], n);
        o[2] = op(a2[2], n);
        return o;
    };
    const d = (o, a2, n)=>{
        !o && (o = a2);
        o[0] = op(a2[0], n);
        o[1] = op(a2[1], n);
        o[2] = op(a2[2], n);
        o[3] = op(a2[3], n);
        return o;
    };
    return [
        (0, $1b0089e3705a02bc$export$c37d18c23b2ea60c)(dispatch, a, b, c, d),
        b,
        c,
        d
    ];
};


const $d6fd4ead405a2554$export$c98a93fd0e0a3243 = (a, b)=>a + b;
const $d6fd4ead405a2554$export$ccbc06046c0e51f7 = (a, b)=>a + b | 0;
const $d6fd4ead405a2554$export$b3d3739ca9163bdb = (a, b)=>a + b >>> 0;
const $d6fd4ead405a2554$export$1f1468f05e2312d9 = (a, b, c)=>(a + b) * c;
const $d6fd4ead405a2554$export$9fbe37310e0b02eb = (a, b)=>a & b;
const $d6fd4ead405a2554$export$192a3a09749a1942 = (a, b)=>(a & b) >>> 0;
const $d6fd4ead405a2554$export$75b1b648b47fdc58 = (a, b)=>a | b;
const $d6fd4ead405a2554$export$ac3ff3dec9f474cf = (a, b)=>(a | b) >>> 0;
const $d6fd4ead405a2554$export$8b0cf57a598a47c4 = (a, b)=>a ^ b;
const $d6fd4ead405a2554$export$a5abda5b71eeaae3 = (a, b)=>(a ^ b) >>> 0;
const $d6fd4ead405a2554$export$3718d30853d1be1 = (a, b)=>a / b;
const $d6fd4ead405a2554$export$9a23643eb28ba785 = (a, b)=>a / b | 0;
const $d6fd4ead405a2554$export$be1c191459c77eee = (a, b)=>a / b >>> 0;
const $d6fd4ead405a2554$export$622b192fdb0901b = (a, b)=>a % b;
const $d6fd4ead405a2554$export$2860860553a43bde = (a, b)=>a << b;
const $d6fd4ead405a2554$export$671bfc93ec67bb2e = (a, b)=>a << b >>> 0;
const $d6fd4ead405a2554$export$f4c7d57dd7548b3d = (a, b, c)=>a * b + c;
const $d6fd4ead405a2554$export$231222e1207e8c38 = (a, b, c)=>a * b - c;
const $d6fd4ead405a2554$export$80848e67be9d82d9 = (a, b, c)=>a + (b - a) * c;
const $d6fd4ead405a2554$export$3015feb668576a61 = (a, b)=>a * b;
const $d6fd4ead405a2554$export$d895fd1da7db968b = (a, b)=>a * b | 0;
const $d6fd4ead405a2554$export$c8eecf5051694b32 = (a, b)=>a * b >>> 0;
const $d6fd4ead405a2554$export$1563167479a235b6 = (a, b)=>a >> b;
const $d6fd4ead405a2554$export$3189654dc6787f54 = (a, b)=>a >>> b;
const $d6fd4ead405a2554$export$d9e26544270342f5 = (a, b)=>a - b;
const $d6fd4ead405a2554$export$d20024cea7f32fb2 = (a, b)=>a - b | 0;
const $d6fd4ead405a2554$export$94e2fc18bf4f8ef7 = (a, b)=>a - b >>> 0;
const $d6fd4ead405a2554$export$e0ca608763397fb5 = (a, b, c)=>(a - b) * c;


const [$287a6df338b22eea$var$a, $287a6df338b22eea$var$b, $287a6df338b22eea$var$c, $287a6df338b22eea$var$d] = (0, $2ff6d5521fe92bed$export$74e86b495c467255)((0, $d6fd4ead405a2554$export$3718d30853d1be1));
const $287a6df338b22eea$export$6747e444d0e25f8e = $287a6df338b22eea$var$a;
const $287a6df338b22eea$export$c8a0e366d15bb712 = $287a6df338b22eea$var$b;
const $287a6df338b22eea$export$cb6d410f870ee721 = $287a6df338b22eea$var$c;
const $287a6df338b22eea$export$9e7986c53a12814a = $287a6df338b22eea$var$d;


const $d1163c21fd816b3b$export$9139dfc05eb4aaca = (op, dispatch = 1, outA = true)=>{
    const a = outA ? (o, a2, b2)=>{
        !o && (o = a2);
        for(let i = a2.length; i-- > 0;)o[i] = op(a2[i], b2[i]);
        return o;
    } : (o, a2, b2)=>{
        !o && (o = b2);
        for(let i = a2.length; i-- > 0;)o[i] = op(a2[i], b2[i]);
        return o;
    };
    const b = outA ? (o, a2, b2)=>{
        !o && (o = a2);
        o[0] = op(a2[0], b2[0]);
        o[1] = op(a2[1], b2[1]);
        return o;
    } : (o, a2, b2)=>{
        !o && (o = b2);
        o[0] = op(a2[0], b2[0]);
        o[1] = op(a2[1], b2[1]);
        return o;
    };
    const c = outA ? (o, a2, b2)=>{
        !o && (o = a2);
        o[0] = op(a2[0], b2[0]);
        o[1] = op(a2[1], b2[1]);
        o[2] = op(a2[2], b2[2]);
        return o;
    } : (o, a2, b2)=>{
        !o && (o = b2);
        o[0] = op(a2[0], b2[0]);
        o[1] = op(a2[1], b2[1]);
        o[2] = op(a2[2], b2[2]);
        return o;
    };
    const d = outA ? (o, a2, b2)=>{
        !o && (o = a2);
        o[0] = op(a2[0], b2[0]);
        o[1] = op(a2[1], b2[1]);
        o[2] = op(a2[2], b2[2]);
        o[3] = op(a2[3], b2[3]);
        return o;
    } : (o, a2, b2)=>{
        !o && (o = b2);
        o[0] = op(a2[0], b2[0]);
        o[1] = op(a2[1], b2[1]);
        o[2] = op(a2[2], b2[2]);
        o[3] = op(a2[3], b2[3]);
        return o;
    };
    return [
        (0, $1b0089e3705a02bc$export$c37d18c23b2ea60c)(dispatch, a, b, c, d),
        b,
        c,
        d
    ];
};



const [$f0c86bfea603695c$var$a, $f0c86bfea603695c$var$b, $f0c86bfea603695c$var$c, $f0c86bfea603695c$var$d] = (0, $d1163c21fd816b3b$export$9139dfc05eb4aaca)((0, $d6fd4ead405a2554$export$d9e26544270342f5));
const $f0c86bfea603695c$export$f93b5905241a7cca = $f0c86bfea603695c$var$a;
const $f0c86bfea603695c$export$27409c384c4283a = $f0c86bfea603695c$var$b;
const $f0c86bfea603695c$export$4d77c846ee8dc708 = $f0c86bfea603695c$var$c;
const $f0c86bfea603695c$export$317805a8a51cab87 = $f0c86bfea603695c$var$d;




const [$cda2e27752b43167$var$a, $cda2e27752b43167$var$b, $cda2e27752b43167$var$c, $cda2e27752b43167$var$d] = (0, $d1163c21fd816b3b$export$9139dfc05eb4aaca)((0, $d6fd4ead405a2554$export$c98a93fd0e0a3243));
const $cda2e27752b43167$export$e16d8520af44a096 = $cda2e27752b43167$var$a;
const $cda2e27752b43167$export$363c2f72629e4a7f = $cda2e27752b43167$var$b;
const $cda2e27752b43167$export$287691874d09163a = $cda2e27752b43167$var$c;
const $cda2e27752b43167$export$81b475958bcba316 = $cda2e27752b43167$var$d;


const $af85f0111202b579$export$7d5e3328550ce0cd = (theta, n = 1)=>[
        Math.sin(theta) * n,
        Math.cos(theta) * n
    ];
const $af85f0111202b579$export$5dceb76539a08116 = (theta, n = 1)=>[
        Math.cos(theta) * n,
        Math.sin(theta) * n
    ];
const $af85f0111202b579$export$8e3badfd6976e5c = (theta)=>(theta %= (0, $de6ddf51c250e19d$export$ad5b0b9ab7d48f58), theta < 0 ? (0, $de6ddf51c250e19d$export$ad5b0b9ab7d48f58) + theta : theta);
const $af85f0111202b579$export$bc9a8c093c36a624 = (theta)=>(theta = Math.abs(theta), theta > (0, $de6ddf51c250e19d$export$6b5c1ceb16d01dc3) ? (0, $de6ddf51c250e19d$export$ad5b0b9ab7d48f58) - theta : theta);
const $af85f0111202b579$export$28d974ff8f7517ed = (a, b)=>$af85f0111202b579$export$bc9a8c093c36a624($af85f0111202b579$export$8e3badfd6976e5c(b % (0, $de6ddf51c250e19d$export$ad5b0b9ab7d48f58) - a % (0, $de6ddf51c250e19d$export$ad5b0b9ab7d48f58)));
const $af85f0111202b579$export$64813598e5fb2450 = (y, x)=>$af85f0111202b579$export$8e3badfd6976e5c(Math.atan2(y, x));
const $af85f0111202b579$export$2332ba17bcdd284d = (theta)=>$af85f0111202b579$export$8e3badfd6976e5c(theta) * (0, $de6ddf51c250e19d$export$24b096bfbaf849b7) | 0;
const $af85f0111202b579$export$61ddd819c68acdd = (theta)=>theta * (0, $de6ddf51c250e19d$export$914076c8150813e5);
const $af85f0111202b579$export$29e4e862bebba87f = (theta)=>theta * (0, $de6ddf51c250e19d$export$460c4029b1a54a2e);
const $af85f0111202b579$export$a830b5ed334924be = (theta)=>1 / Math.sin(theta);
const $af85f0111202b579$export$e17a63917e2ebf0f = (theta)=>1 / Math.cos(theta);
const $af85f0111202b579$export$ef569ec50496610c = (theta)=>1 / Math.tan(theta);
const $af85f0111202b579$export$ebcbd32ce8d4cff = (a, b, gamma)=>Math.sqrt(a * a + b * b - 2 * a * b * Math.cos(gamma));
const $af85f0111202b579$export$c0a907f067762f6e = (x)=>{
    const x2 = x * x;
    return 1 + x2 * (-4 + 2 * x2);
};
const $af85f0111202b579$var$__fastCos = (x)=>{
    const x2 = x * x;
    return 0.99940307 + x2 * (-0.49558072 + 0.03679168 * x2);
};
const $af85f0111202b579$export$3c8033b41bb9b535 = (theta)=>{
    theta %= (0, $de6ddf51c250e19d$export$ad5b0b9ab7d48f58);
    theta < 0 && (theta = -theta);
    switch(theta * (0, $de6ddf51c250e19d$export$24b096bfbaf849b7) | 0){
        case 0:
            return $af85f0111202b579$var$__fastCos(theta);
        case 1:
            return -$af85f0111202b579$var$__fastCos((0, $de6ddf51c250e19d$export$6b5c1ceb16d01dc3) - theta);
        case 2:
            return -$af85f0111202b579$var$__fastCos(theta - (0, $de6ddf51c250e19d$export$6b5c1ceb16d01dc3));
        default:
            return $af85f0111202b579$var$__fastCos((0, $de6ddf51c250e19d$export$ad5b0b9ab7d48f58) - theta);
    }
};
const $af85f0111202b579$export$5a59657e318cc2cf = (theta)=>$af85f0111202b579$export$3c8033b41bb9b535((0, $de6ddf51c250e19d$export$f504979d7e0a75c7) - theta);
const $af85f0111202b579$export$8019a7ebe7afe6d9 = (deg2, min, sec2)=>deg2 + min / 60 + sec2 / 3600;
const $af85f0111202b579$export$6804273a91971333 = (theta)=>{
    const sign = Math.sign(theta);
    theta = Math.abs(theta);
    const deg2 = Math.trunc(theta);
    theta = (theta - deg2) * 60;
    const min = Math.trunc(theta);
    return [
        deg2 * sign,
        min,
        (theta - min) * 60
    ];
};


const $766e00462f877194$export$644e79245f7d24b5 = (out, ...values)=>{
    if (!out) return values;
    for(let i = values.length; i-- > 0;)out[i] = values[i];
    return out;
};
const $766e00462f877194$export$dcfbb7940cfb3a48 = (out, x, y)=>{
    !out && (out = []);
    out[0] = x;
    out[1] = y;
    return out;
};
const $766e00462f877194$export$ba8c70ce75474f8d = (out, x, y, z)=>{
    !out && (out = []);
    out[0] = x;
    out[1] = y;
    out[2] = z;
    return out;
};
const $766e00462f877194$export$abee0037e1db715 = (out, x, y, z, w)=>{
    !out && (out = []);
    out[0] = x;
    out[1] = y;
    out[2] = z;
    out[3] = w;
    return out;
};
const $766e00462f877194$export$d58a46c754825a51 = (out, a, b, c, d, e, f)=>{
    !out && (out = []);
    out[0] = a;
    out[1] = b;
    out[2] = c;
    out[3] = d;
    out[4] = e;
    out[5] = f;
    return out;
};


const $8e567edc2200dcb7$export$78421b6cc4d5c0fa = (a, b)=>a[0] * b[1] - a[1] * b[0];
const $8e567edc2200dcb7$export$ea0ef2e80b79c3dc = (out, a, b)=>(0, $766e00462f877194$export$ba8c70ce75474f8d)(out || a, a[1] * b[2] - a[2] * b[1], a[2] * b[0] - a[0] * b[2], a[0] * b[1] - a[1] * b[0]);



const $71303e1923b13ab2$export$fe6a5064d53faf98 = (a, b)=>a[0] * b[0] + a[1] * b[1];
const $71303e1923b13ab2$export$6f9aa2c904053c13 = (a, b)=>a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
const $71303e1923b13ab2$export$2e1971da4e839d07 = (a, b)=>a[0] * b[0] + a[1] * b[1] + a[2] * b[2] + a[3] * b[3];
const $71303e1923b13ab2$export$94132a0e348806d4 = (0, $1b0089e3705a02bc$export$c37d18c23b2ea60c)(0, (a, b)=>{
    let sum = 0;
    for(let i = a.length; i-- > 0;)sum += a[i] * b[i];
    return sum;
}, $71303e1923b13ab2$export$fe6a5064d53faf98, $71303e1923b13ab2$export$6f9aa2c904053c13, $71303e1923b13ab2$export$2e1971da4e839d07);



const $156a13214767a2a0$export$52e6e29c5689a25f = (a)=>a[0] * a[0] + a[1] * a[1];
const $156a13214767a2a0$export$9bdeebc943bb634d = (a)=>a[0] * a[0] + a[1] * a[1] + a[2] * a[2];
const $156a13214767a2a0$export$af0b3789fa343fbd = (a)=>a[0] * a[0] + a[1] * a[1] + a[2] * a[2] + a[3] * a[3];
const $156a13214767a2a0$export$57ce51e080b800 = (0, $1b0089e3705a02bc$export$c37d18c23b2ea60c)(0, (a)=>{
    let sum = 0;
    for(let i = a.length; i-- > 0;)sum += a[i] * a[i];
    return sum;
}, $156a13214767a2a0$export$52e6e29c5689a25f, $156a13214767a2a0$export$9bdeebc943bb634d, $156a13214767a2a0$export$af0b3789fa343fbd);


const $f9788d7cee25ed89$export$1b9bab504faa9305 = (v)=>Math.sqrt((0, $156a13214767a2a0$export$57ce51e080b800)(v));
const $f9788d7cee25ed89$export$a3e8187e04b23f9d = (v)=>Math.sqrt((0, $156a13214767a2a0$export$52e6e29c5689a25f)(v));
const $f9788d7cee25ed89$export$d5377aec8e8e1831 = (v)=>Math.sqrt((0, $156a13214767a2a0$export$9bdeebc943bb634d)(v));
const $f9788d7cee25ed89$export$a346c4a3bf827372 = (v)=>Math.sqrt((0, $156a13214767a2a0$export$af0b3789fa343fbd)(v));


const $ea69b871393f25e5$export$a495b599d5a65db0 = (a, b, absInner = false)=>{
    const t = Math.atan2((0, $8e567edc2200dcb7$export$78421b6cc4d5c0fa)(a, b), (0, $71303e1923b13ab2$export$fe6a5064d53faf98)(a, b));
    return absInner ? (0, $af85f0111202b579$export$bc9a8c093c36a624)(t) : t;
};
const $ea69b871393f25e5$export$30df601912837ac9 = (a, b, normalize = true, absInner = false)=>{
    const dp = (0, $71303e1923b13ab2$export$6f9aa2c904053c13)(a, b);
    const t = Math.acos(normalize ? dp / ((0, $f9788d7cee25ed89$export$d5377aec8e8e1831)(a) * (0, $f9788d7cee25ed89$export$d5377aec8e8e1831)(b)) : dp);
    return absInner ? (0, $af85f0111202b579$export$bc9a8c093c36a624)(t) : t;
};



const [$df2bf262eabec050$var$a, $df2bf262eabec050$var$b, $df2bf262eabec050$var$c, $df2bf262eabec050$var$d] = (0, $2ff6d5521fe92bed$export$74e86b495c467255)((0, $d6fd4ead405a2554$export$3015feb668576a61));
const $df2bf262eabec050$export$523c9d3eb3d8d990 = $df2bf262eabec050$var$a;
const $df2bf262eabec050$export$b54ddf06b57709b1 = $df2bf262eabec050$var$b;
const $df2bf262eabec050$export$1c0ad2738a5ae4b0 = $df2bf262eabec050$var$c;
const $df2bf262eabec050$export$1f214a01989f466a = $df2bf262eabec050$var$d;


const $d78c574c84cf5ae8$export$7e3df82ee760448c = 20;
const $d78c574c84cf5ae8$export$ac607276a8fe9f0a = 5;
function $d78c574c84cf5ae8$var$coordinatesToScreenSpace(sf, coordinates) {
    return $79cb68d57182f57f$export$3733d0c1f7322831($df2bf262eabec050$export$b54ddf06b57709b1(null, $cda2e27752b43167$export$363c2f72629e4a7f([], coordinates, [
        $d78c574c84cf5ae8$export$7e3df82ee760448c / 2,
        $d78c574c84cf5ae8$export$ac607276a8fe9f0a / 2
    ]), sf));
}
function $d78c574c84cf5ae8$export$b3890eb0ae9dca99(ctx, sf, molecule) {
    const atomRadius = 1.3;
    for (const bond of molecule.bonds){
        const a = molecule.atoms[bond.atoms[0]];
        const b = molecule.atoms[bond.atoms[1]];
        const angleDeg = $ea69b871393f25e5$export$a495b599d5a65db0(a.currentLocation, b.currentLocation);
        const angleRad = angleDeg / 360 * 2 * Math.PI;
        console.log(a.id, b.id, angleRad);
        const bAngleRad = angleRad - Math.PI;
        // Draw two lines between the two atoms, distanced by this amount of radians
        const distance = 0.5;
        for (const offset of [
            distance / 2,
            -distance / 2
        ]){
            const startRad = angleRad + offset;
            const endRad = bAngleRad - offset;
            const startPosition = $79cb68d57182f57f$export$3733d0c1f7322831($cda2e27752b43167$export$363c2f72629e4a7f(null, $df2bf262eabec050$export$b54ddf06b57709b1(null, [
                Math.cos(startRad),
                Math.sin(endRad)
            ], atomRadius), a.currentLocation));
            const endPosition = $79cb68d57182f57f$export$3733d0c1f7322831($cda2e27752b43167$export$363c2f72629e4a7f(null, $df2bf262eabec050$export$b54ddf06b57709b1(null, [
                Math.cos(endRad),
                Math.sin(endRad)
            ], atomRadius), b.currentLocation));
            ctx.beginPath();
            ctx.lineWidth = 0.2 * sf;
            ctx.strokeStyle = "white";
            ctx.shadowBlur = 6;
            ctx.shadowColor = "white";
            const startScreenSpace = $d78c574c84cf5ae8$var$coordinatesToScreenSpace(sf, startPosition);
            const endScreenSpace = $d78c574c84cf5ae8$var$coordinatesToScreenSpace(sf, endPosition);
            ctx.moveTo(startScreenSpace.x, startScreenSpace.y);
            ctx.lineTo(endScreenSpace.x, endScreenSpace.y);
            ctx.stroke();
        }
    }
    for (const atom of molecule.atoms){
        const coords = $d78c574c84cf5ae8$var$coordinatesToScreenSpace(sf, atom.currentLocation);
        ctx.beginPath();
        ctx.arc(coords.x, coords.y, atomRadius * sf, 0, 2 * Math.PI);
        ctx.lineWidth = 0.2 * sf;
        ctx.strokeStyle = atom.color;
        ctx.shadowBlur = 6;
        ctx.shadowColor = atom.color;
        ctx.stroke();
        ctx.beginPath();
        ctx.textAlign = "center";
        ctx.textBaseline = "middle";
        ctx.fillStyle = "white";
        ctx.font = `${sf * 1}px sans-serif`;
        ctx.textRendering = "optimizeLegibility";
        ctx.shadowBlur = 5;
        ctx.shadowColor = "white";
        ctx.fillText(atom.text, coords.x, coords.y);
    }
}



const $a34fc29bf25d13bd$export$cd11e54b9942fbce = {
    atoms: [
        {
            id: 0,
            text: "N",
            color: "white",
            home: $79cb68d57182f57f$export$e9830bc863290a54(-6, 0),
            currentLocation: $79cb68d57182f57f$export$e9830bc863290a54(-6, 0)
        },
        {
            id: 1,
            text: "N",
            color: "white",
            home: $79cb68d57182f57f$export$e9830bc863290a54(0, 0),
            currentLocation: $79cb68d57182f57f$export$e9830bc863290a54(0, 0)
        },
        {
            id: 2,
            text: "O",
            color: "#7dd3fc",
            home: $79cb68d57182f57f$export$e9830bc863290a54(6, 0),
            currentLocation: $79cb68d57182f57f$export$e9830bc863290a54(6, 0)
        }
    ],
    bonds: [
        {
            atoms: [
                0,
                1
            ],
            targetLength: 5,
            strength: 1
        },
        {
            atoms: [
                1,
                2
            ],
            targetLength: 5,
            strength: 1
        }
    ]
};



const $9ca1722b712bf23b$export$9c2d4f405359337 = (op, dispatch = 1)=>{
    const a = (o, a2)=>{
        !o && (o = a2);
        for(let i = a2.length; i-- > 0;)o[i] = op(a2[i]);
        return o;
    };
    const b = (o, a2)=>{
        !o && (o = a2);
        o[0] = op(a2[0]);
        o[1] = op(a2[1]);
        return o;
    };
    const c = (o, a2)=>{
        !o && (o = a2);
        o[0] = op(a2[0]);
        o[1] = op(a2[1]);
        o[2] = op(a2[2]);
        return o;
    };
    const d = (o, a2)=>{
        !o && (o = a2);
        o[0] = op(a2[0]);
        o[1] = op(a2[1]);
        o[2] = op(a2[2]);
        o[3] = op(a2[3]);
        return o;
    };
    return [
        (0, $1b0089e3705a02bc$export$c37d18c23b2ea60c)(dispatch, a, b, c, d),
        b,
        c,
        d
    ];
};


const [$62ebfc6d9cd00ef6$var$a, $62ebfc6d9cd00ef6$var$b, $62ebfc6d9cd00ef6$var$c, $62ebfc6d9cd00ef6$var$d] = (0, $9ca1722b712bf23b$export$9c2d4f405359337)((a2)=>-a2);
const $62ebfc6d9cd00ef6$export$d9493ff0dfa0fdd5 = $62ebfc6d9cd00ef6$var$a;
const $62ebfc6d9cd00ef6$export$bea5fcabffc8cbd5 = $62ebfc6d9cd00ef6$var$b;
const $62ebfc6d9cd00ef6$export$740c655f931871a0 = $62ebfc6d9cd00ef6$var$c;
const $62ebfc6d9cd00ef6$export$c58f78074faa67ac = $62ebfc6d9cd00ef6$var$d;





const $79242b68cb5911a5$export$55640438a4edf3d6 = (o, a)=>{
    !o && (o = []);
    o[0] = a[0];
    o[1] = a[1];
    return o;
};
const $79242b68cb5911a5$export$9cbac02f28c9a9a9 = (o, a)=>{
    !o && (o = []);
    o[0] = a[0];
    o[1] = a[1];
    o[2] = a[2];
    return o;
};
const $79242b68cb5911a5$export$a7c139a4194832bf = (o, a)=>{
    !o && (o = []);
    o[0] = a[0];
    o[1] = a[1];
    o[2] = a[2];
    o[3] = a[3];
    return o;
};
const $79242b68cb5911a5$export$adaa4cf7ef1b65be = (0, $1b0089e3705a02bc$export$c37d18c23b2ea60c)(1, (o, a)=>{
    !o && (o = []);
    for(let i = a.length; i-- > 0;)o[i] = a[i];
    return o;
}, $79242b68cb5911a5$export$55640438a4edf3d6, $79242b68cb5911a5$export$9cbac02f28c9a9a9, $79242b68cb5911a5$export$a7c139a4194832bf);


const $6bba786ab5a73639$var$$ = (magSq5, mulN5, set5)=>(out, v, n = 1)=>{
        !out && (out = v);
        const m = Math.sqrt(magSq5(v));
        return m >= (0, $de6ddf51c250e19d$export$56469a43a57ad8b6) ? mulN5(out, v, n / m) : out !== v ? set5(out, v) : out;
    };
const $6bba786ab5a73639$export$a3295358bff77e = $6bba786ab5a73639$var$$((0, $156a13214767a2a0$export$57ce51e080b800), (0, $df2bf262eabec050$export$523c9d3eb3d8d990), (0, $79242b68cb5911a5$export$adaa4cf7ef1b65be));
const $6bba786ab5a73639$export$cb6730ea375ab516 = $6bba786ab5a73639$var$$((0, $156a13214767a2a0$export$52e6e29c5689a25f), (0, $df2bf262eabec050$export$b54ddf06b57709b1), (0, $79242b68cb5911a5$export$55640438a4edf3d6));
const $6bba786ab5a73639$export$6feaa6aa9769ce13 = $6bba786ab5a73639$var$$((0, $156a13214767a2a0$export$9bdeebc943bb634d), (0, $df2bf262eabec050$export$1c0ad2738a5ae4b0), (0, $79242b68cb5911a5$export$9cbac02f28c9a9a9));
const $6bba786ab5a73639$export$e630f428d5718f7b = $6bba786ab5a73639$var$$((0, $156a13214767a2a0$export$af0b3789fa343fbd), (0, $df2bf262eabec050$export$1f214a01989f466a), (0, $79242b68cb5911a5$export$a7c139a4194832bf));


function $951a97753eeeb92a$export$55d7f61db91b7b70(molecule, t, lastT, cursorPosition) {
    const dt = t - lastT;
    for (const atom of molecule.atoms){
        // Apply slight force based on sine float
        const sineFloatPeriodMS = 5000;
        const sineFloatMagnitude = 0.00015;
        const sineFloatForce = sineFloatMagnitude * Math.sin((t / sineFloatPeriodMS + atom.id / molecule.atoms.length) * 2 * Math.PI);
        $cda2e27752b43167$export$363c2f72629e4a7f(null, atom.currentLocation, $79cb68d57182f57f$export$e9830bc863290a54(0, sineFloatForce * dt));
        // Apply a repelling force based on the cursor
        if (cursorPosition != null) {
            const distanceFromCursor = $f0c86bfea603695c$export$27409c384c4283a([], atom.currentLocation, cursorPosition);
            const cursorRepellingMagnitude = 0.009;
            $cda2e27752b43167$export$363c2f72629e4a7f(null, atom.currentLocation, $df2bf262eabec050$export$b54ddf06b57709b1(null, $6bba786ab5a73639$export$cb6730ea375ab516([], distanceFromCursor), cursorRepellingMagnitude));
        }
        // Apply force based on distance to home
        const distanceToHome = $f0c86bfea603695c$export$27409c384c4283a([], atom.currentLocation, atom.home);
        const homeDistanceMagnitude = 0.008;
        const homeDistanceForce = $62ebfc6d9cd00ef6$export$bea5fcabffc8cbd5(null, $df2bf262eabec050$export$b54ddf06b57709b1([], distanceToHome, homeDistanceMagnitude));
        $cda2e27752b43167$export$363c2f72629e4a7f(null, atom.currentLocation, homeDistanceForce);
    }
}


function $3d21ec4c20bb3a0a$var$run() {
    const canvas = document.getElementById("molecule-canvas");
    if (canvas == null) {
        console.error("No canvas for molecule!");
        return;
    }
    if (!(canvas instanceof HTMLCanvasElement)) {
        console.error("#molecule-canvas isn't a canvas!");
        return;
    }
    const context = canvas.getContext("2d");
    if (context == null) {
        console.error("Couldn't get rendering context");
        return;
    }
    let mousePosition = null;
    canvas.addEventListener("mousemove", function(e) {
        const relativeX = e.clientX - canvas.offsetLeft;
        const relativeY = e.clientY - canvas.offsetTop;
        if (relativeX > 0 && relativeX < canvas.width && relativeY > 0 && relativeY < canvas.height) mousePosition = $79cb68d57182f57f$export$e9830bc863290a54(relativeX, relativeY);
        else mousePosition = null;
    });
    canvas.addEventListener("mouseleave", function() {
        mousePosition = null;
    });
    function runRender(lastT) {
        const t = performance.now();
        // Get the DPR and size of the canvas
        const dpr = window.devicePixelRatio;
        const rect = canvas.getBoundingClientRect();
        // Set the "actual" size of the canvas
        canvas.width = rect.width * dpr;
        canvas.height = rect.height * dpr;
        // Scale the context to ensure correct drawing operations
        context.scale(dpr, dpr);
        // Set the "drawn" size of the canvas
        canvas.style.width = `${rect.width}px`;
        canvas.style.height = `${rect.height}px`;
        const sf = Math.min(rect.width / (0, $d78c574c84cf5ae8$export$7e3df82ee760448c), rect.height / (0, $d78c574c84cf5ae8$export$ac607276a8fe9f0a));
        const scaledMousePosition = mousePosition == null ? null : $79cb68d57182f57f$export$3733d0c1f7322831($f0c86bfea603695c$export$27409c384c4283a([], $287a6df338b22eea$export$c8a0e366d15bb712([], mousePosition, sf), [
            (0, $d78c574c84cf5ae8$export$7e3df82ee760448c) / 2,
            (0, $d78c574c84cf5ae8$export$ac607276a8fe9f0a) / 2
        ]));
        (0, $951a97753eeeb92a$export$55d7f61db91b7b70)((0, $a34fc29bf25d13bd$export$cd11e54b9942fbce), t, lastT, scaledMousePosition);
        (0, $d78c574c84cf5ae8$export$b3890eb0ae9dca99)(context, sf, (0, $a34fc29bf25d13bd$export$cd11e54b9942fbce));
        requestAnimationFrame(()=>runRender(t));
    }
    runRender(performance.now());
}
$3d21ec4c20bb3a0a$var$run();


//# sourceMappingURL=repo.a8649f4c.js.map
